module.exports = __webpack_public_path__ + "img/LamdeiniLearning-47.9be0e54d.jpg";